export function renderReminderModal(container, { isOpen, activeNote, onClose, onSaveReminder }) {
  if (!isOpen) {
    container.innerHTML = '';
    return;
  }

  const existingDate = activeNote?.reminderAt ? new Date(activeNote.reminderAt).toISOString().slice(0, 16) : '';

  container.innerHTML = `
    <div class="sheet-backdrop open" id="reminder-backdrop"></div>
    <div class="sheet-modal open" id="reminder-modal" style="top: 20%;">
      <div class="sheet-handle-bar"></div>
      <div class="sheet-header">
        <div class="sheet-top-row">
          <span class="sheet-title">Set Reminder 🔔</span>
          <button class="icon-btn" id="btn-close-reminder">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
      </div>

      <div style="padding: 20px;">
        <div class="reminder-chips">
          <button class="chip-btn" id="chip-today">Later today (+3h)</button>
          <button class="chip-btn" id="chip-tomorrow">Tomorrow 9 AM</button>
          <button class="chip-btn" id="chip-nextweek">Next week</button>
        </div>

        <label style="display: block; font-size: 13px; font-weight: 600; color: var(--ink-secondary); margin-bottom: 8px;">Or pick custom time:</label>
        <input type="datetime-local" class="datetime-picker" id="reminder-custom-date" value="${existingDate}">

        <div style="display: flex; gap: 10px; margin-top: 24px;">
          ${activeNote?.reminderAt ? `
            <button class="chip-btn" id="btn-clear-reminder" style="background: rgba(220,38,38,0.1); color: #DC2626; flex: 1;">Clear</button>
          ` : ''}
          <button class="chip-btn" id="btn-save-reminder" style="background: var(--signal-blue); color: white; flex: 2; font-weight: 700;">Save Reminder</button>
        </div>
      </div>
    </div>
  `;

  const backdrop = container.querySelector('#reminder-backdrop');
  if (backdrop) backdrop.onclick = onClose;

  const closeBtn = container.querySelector('#btn-close-reminder');
  if (closeBtn) closeBtn.onclick = onClose;

  const saveBtn = container.querySelector('#btn-save-reminder');
  const customInput = container.querySelector('#reminder-custom-date');

  const setTimeAndSave = (isoString) => {
    if (Notification && Notification.permission !== 'granted') {
      Notification.requestPermission();
    }
    if (onSaveReminder) onSaveReminder(isoString);
    onClose();
  };

  const chipToday = container.querySelector('#chip-today');
  if (chipToday) {
    chipToday.onclick = () => {
      const d = new Date(Date.now() + 3 * 60 * 60 * 1000);
      setTimeAndSave(d.toISOString());
    };
  }

  const chipTomorrow = container.querySelector('#chip-tomorrow');
  if (chipTomorrow) {
    chipTomorrow.onclick = () => {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      d.setHours(9, 0, 0, 0);
      setTimeAndSave(d.toISOString());
    };
  }

  const chipNextWeek = container.querySelector('#chip-nextweek');
  if (chipNextWeek) {
    chipNextWeek.onclick = () => {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      d.setHours(9, 0, 0, 0);
      setTimeAndSave(d.toISOString());
    };
  }

  if (saveBtn && customInput) {
    saveBtn.onclick = () => {
      if (customInput.value) {
        const d = new Date(customInput.value);
        setTimeAndSave(d.toISOString());
      }
    };
  }

  const clearBtn = container.querySelector('#btn-clear-reminder');
  if (clearBtn) {
    clearBtn.onclick = () => setTimeAndSave(null);
  }
}
